import { lazy } from "react";
import { RouteObject } from "react-router-dom";

// Folders
const TestsListPage = lazy(
  () =>
    import(
      "@/features/admin-view/icares-test-management/pages/tests-list-admin"
    )
);
// const FoldersViewPage = lazy(
//   () => import("@/features/folders/pages/folders-view")
// );

export const icaresRoutes: RouteObject[] = [
  {
    path: "/admin/manage-icares-tests",
    element: <TestsListPage />,
  },
];
